import { updateDepartureInfo } from '@/api';
import FlexWrap from '@/components/common/FlexWrap';
import TextButton from '@/components/common/TextButton';
import { HOME_TOP_SECTION } from '@/constants/home.const';
import { routes } from '@/constants/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState, initialGlobalState } from '@/store';
import { IUpdateDepartureInfoPayload } from '@/types/common.type';
import {
  DepartureDate,
  MTCN,
  RefundAmount,
  RefundDetail,
} from '@repo/components';
import { MTCN as MTCNType } from '@repo/types';
import { format } from 'date-fns';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import CurrentStatus from './CurrentStatus';
import ReceiptAccordionContent from './ReceiptAccordionContent';

type Props = {
  mtcnList: MTCNType[];
};

function TopSection({ mtcnList }: Props) {
  const dispatch = useAppDispatch();
  const {
    refundAfter,
    nationality,
    departureDate,
    refundAmountDetail,
    passportNumber,
    email,
    firstRefundDate,
    refundAfterAmount,
    refundAmount,
    isUploadRequired,
  } = useAppSelector((state) => state) as IGlobalState;
  const [refundDetail, setRefundDetail] = useState(false);
  const history = useHistory();

  const { mutate: putDepartureDate } = useMutation(
    ['deaprtureDate'],
    (payload: IUpdateDepartureInfoPayload) => updateDepartureInfo(payload),
  );

  const updateDepartureDate = (departure: string) => {
    const departureDate = format(new Date(departure || ''), 'yyyy-MM-dd');
    putDepartureDate(
      {
        passportNumber,
        email,
        departureDate,
      },
      {
        onSuccess: () => {
          dispatch({
            type: 'UPDATE_USER_INFO',
            payload: { departureDate },
          });
        },
      },
    );
  };

  const onCloseModal = () =>
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: {
        isActive: false,
        type: null,
        data: null,
      },
    });

  const onOpenLogoutModal = () => {
    const logoutModalContent =
      HOME_TOP_SECTION.getLogoutModalContent(nationality);

    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: {
        isActive: true,
        type: 'CUSTOM',
        data: {
          ...logoutModalContent,
          btnCallback: logout,
        },
      },
    });
  };

  const logout = () => {
    onCloseModal();
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: initialGlobalState,
    });
    localStorage.clear();
    history.push(routes.passport);
  };

  const handleRefundAmountClick = () => {
    // if (isUploadRequired) {
    //   history.push({
    //     pathname: routes.airportPrintReceipt,
    //     state: {
    //       refundAmount: refundAfter ? refundAfterAmount : refundAmount,
    //     },
    //   });
    // } else {
    history.push({
      pathname: routes.receipt,
      state: {
        refundAmount: refundAfter ? refundAfterAmount : refundAmount,
      },
    });
    // }
  };

  return (
    <Container dir='column' justifyContent='center'>
      <HeaderWrapper>
        {refundAfter && (
          <DepartureDate
            nationality={nationality}
            departureDate={departureDate || ''}
            firstRefundDate={firstRefundDate}
            onClick={updateDepartureDate}
          />
        )}
      </HeaderWrapper>
      <CurrentStatus />
      {mtcnList.length > 0 && <MTCN data={mtcnList} />}
      <RefundAmount
        refundAmount={Number(refundAfter ? refundAfterAmount : refundAmount)}
        nation={nationality}
        onClick={handleRefundAmountClick}
      />
      {!refundAfter && (
        <>
          <TextButton
            title={HOME_TOP_SECTION.getLogoutButtonText(nationality)}
            onClick={onOpenLogoutModal}
            color='#1856CD'
            bgColor='#fff'
            outline
            margin='28px 0'
          />
          <ReceiptAccordionContent />
        </>
      )}
      {refundDetail && (
        <RefundDetail
          nation={nationality}
          refund={refundAmountDetail.refunded}
          remittance={refundAmountDetail.remittance}
          van={refundAmountDetail.van}
          unRefund={refundAmountDetail.unRefunded}
          onClose={() => setRefundDetail(false)}
        />
      )}
    </Container>
  );
}

export default TopSection;

const Container = styled(FlexWrap)`
  padding: 0 20px 20px;
  width: 375px;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
`;
